import { NavLink } from "react-router-dom";

const DataTable = ({ customerCategories, handleDelete }) => {

    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th className="text-left" width="20%">Name</th>
                    <th className="text-left">Description</th>
                    <th className="text-left" width="1%"/>
                    <th className="text-left" width="1%"/>
                </tr>
            </thead>
            <tbody>
                {customerCategories.map(customerCategory => 
                    <tr key={customerCategory.id} className="hover:bg-gray-100">
                        <td>{customerCategory.name}</td>
                        <td>{customerCategory.description}</td>
                        <td>
                            <NavLink to={`/data/customer-categories/${customerCategory.id}`} className="btn btn-primary btn-icon">
                                <span className="las la-pen" />
                            </NavLink>
                        </td>
                        <td>
                            <button className="btn btn-danger btn-icon" onClick={() => handleDelete(customerCategory)}>
                                <span className="las la-trash-alt" />
                            </button>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}
 
export default DataTable;